interface MaintenanceObjectiveProps {
  systemDisplayName: string | undefined;
  actionDisplayName: string | undefined;
  partDisplayName: string | undefined;
  actionDescription?: string;
}

const MaintenanceObjectiveNew = ({
  systemDisplayName,
  actionDisplayName,
  partDisplayName,
  actionDescription,
}: MaintenanceObjectiveProps) => {
  return (
    <div className="flex items-center gap-1">
      <p className="font-bold text-sm leading-normal">
        <span className="text-blue-800">{actionDisplayName}</span> {partDisplayName}{systemDisplayName && (
          <>
            {' '}<span className="font-normal">em</span> {systemDisplayName}
          </>
        )}
      </p>

      <p className="text-xs leading-normal text-white-300">
        |
      </p>

      <p className="text-xs leading-normal">
        {actionDescription}
      </p>
    </div>
  );
}

export default MaintenanceObjectiveNew;
